// export {} // NOTE: makes the file a module
// import{ PlaceResult, PlacesServiceStatus } from 'google.maps.places'
// import * as GMaps from 'google.maps'
// import PlaceResult = google.maps.places.PlaceResult
// import PlacesServiceStatus = google.maps.places.PlacesServiceStatus
import {
	AppClipsCapability,
	appClipsCapability,
	BaseURL,
	launchApp as GLOBAL_launchApp,
	launchAppClip, ShouldAppClipsLaunchViaAppleLinks,
	ShouldLaunchApp,
	ShouldLaunchAppClip,
	ViewUtils,
	debounce,
} from './Core'
import { Loader } from '@googlemaps/js-api-loader'
import {
	AppType,
	CommercialLevel,
	GLOBAL_AppPlatform,
	Metrics,
	Page,
	PitchType,
	Platform,
	RegionsType,
	TriggerPoint,
} from './Metrics'
import { RegionVM } from './Models/RegionVM'
import LatLng = google.maps.LatLng
import { ActionBar } from './Shared/ActionBar'
import { global } from 'yargs'
declare const GLOBAL_GoogleMapsAPIKey:string
declare const _region:RegionVM
declare const DEBUG_IncludePreviewData:boolean|undefined
declare const DEBUG_shouldLoadImages:boolean
declare const DEBUG_DebugMode:boolean|undefined

let DEBUG_includePreviewData:boolean = (typeof(DEBUG_IncludePreviewData) !== 'undefined') && DEBUG_IncludePreviewData
let DEBUG_debugMode:boolean = (typeof(DEBUG_DebugMode) !== 'undefined') && DEBUG_DebugMode

// services
let placesService:google.maps.places.PlacesService

// views
let HACK_map:google.maps.Map

// data

let metrics_regionBarViewed:boolean = false
let metrics_mapCTAViewed:boolean = false
let metrics_topSightsViewed:boolean = false
let metrics_appPitch1Viewed:boolean = false
let metrics_appPitch2Viewed:boolean = false
let metrics_otherSightsViewed:boolean = false
let metrics_otherSightsCTAViewed:boolean = false
let metrics_nearbyRegionsViewed:boolean = false
let metrics_primaryCTAViewed:boolean = false
// let metrics_secondaryCTAViewed:boolean = false // TODO(arch): should we keep ignoring these after the first view?
let metrics_preFooterPitchViewed:boolean = false
let metrics_preRegistrationViewed:boolean = false


//
// init
//

// REF: https://developers.google.com/maps/documentation/javascript/overview#js_api_loader_package
new Loader({
	apiKey: GLOBAL_GoogleMapsAPIKey,
	version: 'weekly',
	libraries: ['places']
}).load().then( () => {
	initMap()
})


function initMap() {
	// A1 – NOTE: we do not use the map in any way
	const sydney:LatLng = new google.maps.LatLng( -33.867, 151.195 )
	HACK_map = new google.maps.Map( // NOTE: map is unused
		document.getElementById( 'map' ), { center: sydney, zoom: 15 })
	placesService = new google.maps.places.PlacesService( HACK_map )
}


const handleParallaxEffect = ({ container, element, multiplier = 10, direction = 1 }: {
	container:HTMLElement,
	element:HTMLElement,
	/**
	 * Control movement speed and range
	 */
	multiplier?:number,
	direction?:number
}) => {
	if( !element ) 
		return
	
	const rect:DOMRect = container.getBoundingClientRect()
	const scrollAmount:number = (rect.top / window.innerHeight) * multiplier * direction
	element.style.transform = `translateY(${scrollAmount}px)`
}


function initPlaceCardParallax() {
	const cards:NodeListOf<Element> = document.querySelectorAll( '.place-container' )
	const visibleCards = new Set<HTMLElement>()
	
	
	const handleScroll = () => {
		requestAnimationFrame(() => {
			visibleCards.forEach(( card:HTMLElement ) => {
				handleParallaxEffect({
					container: card,
					element: card.querySelector( '.showcase-container' ),
					multiplier: 40,
					direction: -1
				})
			})
		})
	}
	
	
	// IntersectionObserver to track visible cards
	const observer = new IntersectionObserver(
		(entries:IntersectionObserverEntry[]) => {
			entries.forEach(( entry ) => {
				if( entry.isIntersecting ){
					visibleCards.add( entry.target as HTMLElement )
				} else {
					visibleCards.delete( entry.target as HTMLElement )
				}
			})
		},
	)

	
	cards.forEach(( card ) => observer.observe( card ))
	window.addEventListener( "scroll", handleScroll )
	// Initial call on load
	handleScroll()
}

$( async () => {
	const Experiments = await loadExperiments()

	if( Experiments?.isUI_RegionPageParallaxItemsEnabled() ){
		$('#topSights').addClass( 'parallax' )
		initPlaceCardParallax()
	}
	if( Experiments.isUI_RegionPagePlaceRatingsEnabled() )
		$('.rating-container').removeClass( 'd-none' )
	if( Experiments.isUI_RegionPagePricingInfoEnabled() )
		$('.pricing-info-container').removeClass( 'd-none' )
	if( Experiments?.isUI_RegionPagePrimaryCTAIconEnabled() )
		$('.actionBarCTAImage').addClass( 'dashed' )

	const text:string = Experiments?.getUI_RegionPagePrimaryCTAText()
	if( text )
		$('#__actionBar #actionBarCTALabel').text(`${text} in Happ`)

	trackActivePlace({
		isHighlightingEnabled: Experiments?.isUI_RegionPageItemHighlightingEnabled() ?? false
	})
})

$( async function() {
	// init
	const actionBar = new ActionBar(Page.RegionPage)
	
	$('#__regionBarButtons > #marketsPicker').on( 'show.bs.dropdown', async event => {
		Metrics.logUI_regionPickerListViewed( Page.RegionPage, RegionsType.Markets )
	})
	$('#__regionBarButtons > #regionsPicker').on( 'show.bs.dropdown', async event => {
		Metrics.logUI_regionPickerListViewed( Page.RegionPage, RegionsType.Regions )
	})
	$('.region-button').on( 'click', async event => {
		let marketButton:JQuery<HTMLElement> = $(event.currentTarget)
		let regionIdentifier:string = marketButton.attr( 'data-region' )
		
		// navigate
		await showRegion( regionIdentifier, TriggerPoint.RegionBar )
	})
	$('.action-button').on( 'click', async event => {
		let ctaButton:JQuery<HTMLElement> = $(event.currentTarget)
		let href:string = ctaButton.attr( 'data-href' )

		await launchApp( href, TriggerPoint.SecondaryCTA )
	})
	$('.place-container').on( 'click', async event => {
		let placeContainer:JQuery<HTMLElement> = $(event.currentTarget)
		let href:string = placeContainer.attr( 'data-href' )
		
		await launchApp( href, TriggerPoint.ListItem )
	})
	$('.destination-card').on( 'click', async event => {
		let destinationCard:JQuery<HTMLElement> = $(event.currentTarget)
		let regionIdentifier:string = destinationCard.attr( 'data-id' )
		let href:string = destinationCard.attr( 'data-href' )
		
		await showRegion( regionIdentifier, TriggerPoint.ListItem )
	})
	async function showRegion( identifier:string, triggerPoint:TriggerPoint ){
		Metrics.logNAV_viewRegion( identifier, Page.RegionPage, triggerPoint )

		// navigate
		let params:Record<string, any> = { trigger: triggerPoint }
		if( DEBUG_includePreviewData )
			params['preview'] = true
		if( DEBUG_debugMode == true )
			params['dbg'] = true
		const queryParams:string = (0 < Object.keys( params ).length) ? `?${jQuery.param( params )}` : ''
		console.debug( `Navigating to region '${identifier} (trigger: ${triggerPoint})...` )
		await Metrics.flush() // NOTE: ensure metrics are pushed before navigating away
		window.location.href = `${BaseURL}/explore/${identifier}${queryParams}`
	}
	// TODO(DRY)
	async function launchApp( href:string, triggerPoint:TriggerPoint ){
		let appType:AppType = (appClipsCapability == AppClipsCapability.Full) ? AppType.Transient : AppType.Permanent
		if( GLOBAL_AppPlatform == Platform.iOS ) // TEMP: workaround for Amplitude bug where filters are not respected when syncing
			await Metrics.logNAV_launchApp( appType, Page.RegionPage, triggerPoint )

		// navigate
		console.debug( `Launching app (HREF: ${href}, trigger: ${triggerPoint})...` )
		await Metrics.flush() // NOTE: ensure metrics are pushed before navigating away
		window.location.href = href
	}
	
	
	//
	// scroll triggers
	//
	// const regionBarContainer:HTMLElement = $('#regionBarContainer')[0]
	const titleLabel:HTMLElement = $('#titleLabel')[0]
	const quickFactsView:HTMLElement = $('#quickFacts')[0]
	const mapCTA:HTMLElement = $('#mapCTA')[0]
	const topSightsSection:HTMLElement = $('#topSights')[0]
	const appPitch1Header:HTMLElement|null = $('#appPitch1 > h4')[0]
	const appPitch2Header:HTMLElement|null = $('#appPitch2 > h4')[0]
	const otherSightsSection:HTMLElement = $('#otherSights')[0]
	const otherSightsCTA:HTMLElement = $('#otherSightsCTA')[0]
	const nearbyRegionsSection:HTMLElement = $('#nearbyRegions')[0]
	const preFooterView:HTMLElement = $('#__preFooter')[0]
	// const preRegistrationView:HTMLElement = $('#__preRegistration')[0]
	const footerView:HTMLElement = $('footer')[0]
	
	const CTAPlacementRanks = {
		MapView: 1,
		AppPitch1: 2,
		AppPitch2: 3,
		OtherSights: 4,
		Footer: 5,
	}
	// CTAs (top)
	// TODO: revive when Quick Facts is revived/introduced 
	// ViewUtils.performWhenScrollingOutOfView( quickFactsView, () => {
	
	
	ViewUtils.performWhenScrollingOutOfView( titleLabel, () => {
		// console.debug( 'Show action bar (top)' )
		showRegionBar()
		actionBar.show()
		showSideBar()
		if( !metrics_regionBarViewed ){
			metrics_regionBarViewed = true
			Metrics.logUI_regionPickerViewed( Page.RegionPage )
		}
		if( !metrics_primaryCTAViewed ){
			metrics_primaryCTAViewed = true
			Metrics.logUI_CTAViewed( Page.RegionPage, TriggerPoint.PrimaryCTA, actionBar.style )
		}
	})
	// performWhenScrollingOutOfView( quickFactsView, () => {
	// 	// console.debug( 'Show side bar (top)' )
	// 	showSideBar()
	// })
	// ViewUtils.performWhenScrollingIntoView( quickFactsView, () => {
	ViewUtils.performWhenScrollingIntoView( titleLabel, () => {
		// console.debug( 'Hide action bar (top)' )
		hideRegionBar()
		actionBar.hide()
		// hideSideBar()
	})
	ViewUtils.performWhenScrollingIntoView( quickFactsView, () => {
		// console.debug( 'Hide side bar (top)' )
		hideSideBar()
	})
	ViewUtils.performWhenScrollingIntoView( mapCTA, () => {
		if( metrics_mapCTAViewed )
			return

		Metrics.logUI_CTAViewed( Page.RegionPage, TriggerPoint.SecondaryCTA, null, CTAPlacementRanks.MapView )
		metrics_mapCTAViewed = true
	}, {
		threshold: 0.5,
	})
	
	// sections
	ViewUtils.performWhenScrollingIntoView( topSightsSection, () => {
		if( metrics_topSightsViewed ){
			// TODO(POLISH): un-wire this, since it's a one-time execution
			return
		}
		
		metrics_topSightsViewed = true
		Metrics.logUI_regionPage_topSightsSectionViewed( _region.Identifier )
	})
	ViewUtils.performWhenScrollingIntoView( otherSightsSection, () => {
		if( metrics_otherSightsViewed ){
			// TODO(POLISH): un-wire this, since it's a one-time execution
			return
		}

		metrics_otherSightsViewed = true
		Metrics.logUI_regionPage_otherSightsSectionViewed( _region.Identifier )
	})
	ViewUtils.performWhenScrollingIntoView( otherSightsCTA, () => {
		if( metrics_otherSightsCTAViewed ){
			// TODO(POLISH): un-wire this, since it's a one-time execution
			return
		}

		metrics_otherSightsCTAViewed = true
		Metrics.logUI_CTAViewed( Page.RegionPage, TriggerPoint.SecondaryCTA, null, CTAPlacementRanks.OtherSights )
	})
	ViewUtils.performWhenScrollingIntoView( nearbyRegionsSection, () => {
		if( metrics_nearbyRegionsViewed ){
			// TODO(PERF): un-wire this, since it's a one-time execution
			return
		}

		metrics_nearbyRegionsViewed = true
		Metrics.logUI_regionPage_nearbyRegionsSectionViewed( _region.Identifier )
	})
	
	// pitches
	if( appPitch1Header != null ){
		ViewUtils.performWhenScrollingIntoView( appPitch1Header, () => {
			if( metrics_appPitch1Viewed ){
				// TODO(PERF): un-wire this, since it's a one-time execution
				return
			}

			metrics_appPitch1Viewed = true
			Metrics.logUI_pitchViewed( PitchType.Expertise, Page.RegionPage, 1 )
			Metrics.logUI_CTAViewed( Page.RegionPage, TriggerPoint.SecondaryCTA, null, CTAPlacementRanks.AppPitch1 )
		})
	}
	if( appPitch2Header != null ){
		ViewUtils.performWhenScrollingIntoView( appPitch2Header, () => {
			if( metrics_appPitch2Viewed ){
				// TODO(PERF): un-wire this, since it's a one-time execution
				return
			}

			metrics_appPitch2Viewed = true
			Metrics.logUI_pitchViewed( PitchType.Logistics, Page.RegionPage, 2 )
			Metrics.logUI_CTAViewed( Page.RegionPage, TriggerPoint.SecondaryCTA, null, CTAPlacementRanks.AppPitch2 )
		})
	}
	ViewUtils.performWhenScrollingIntoView( preFooterView, () => {
		if( metrics_preFooterPitchViewed ){
			// TODO(PERF): un-wire this, since it's a one-time execution
			return
		}

		metrics_preFooterPitchViewed = true
		Metrics.logUI_pitchViewed( PitchType.App, Page.RegionPage, 3 )
		Metrics.logUI_CTAViewed( Page.RegionPage, TriggerPoint.FooterCTA, null, CTAPlacementRanks.Footer )
	})

	// pre-registration
	// ViewUtils.performWhenScrollingIntoView( preRegistrationView, () => {
	// 	if( metrics_preRegistrationViewed ){
	// 		// TODO(PERF): un-wire this, since it's a one-time execution
	// 		return
	// 	}
	//
	// 	metrics_preRegistrationViewed = true
	// 	Metrics.logUI_preRegistrationViewed( Page.RegionPage )
	// })
	
	
	// CTAs (bottom)
	ViewUtils.performWhenScrollingIntoView( [preFooterView, footerView], () => {
		// console.debug( 'Hide action bar (bottom)' )
		hideRegionBar()
		actionBar.hide()
		hideSideBar()
	})
	ViewUtils.performWhenScrollingOutOfView( [preFooterView, footerView], () => {
		// NOTE: prevent conflict with top/bottom triggers
		if( /*not scrolled past top CTA*/0 < titleLabel.getBoundingClientRect().top
			///*not scrolled past top CTA*/0 < quickFactsView.getBoundingClientRect().top
			|| /*scrolled past pre-footer*/preFooterView.getBoundingClientRect().top < 0
		) return

		// console.debug( 'Show action bar (bottom)' )
		showRegionBar()
		actionBar.show()
		showSideBar()

		if( !metrics_regionBarViewed ){
			metrics_regionBarViewed = true
			Metrics.logUI_regionPickerViewed( Page.RegionPage )
		}
		if( !metrics_primaryCTAViewed ){
			metrics_primaryCTAViewed = true
			Metrics.logUI_CTAViewed( Page.RegionPage, TriggerPoint.PrimaryCTA, actionBar.style )
		}
	})

	function showRegionBar() {
		$('#regionBarContainer').addClass( 'is-active' )
	}
	function hideRegionBar() {
		$('#regionBarContainer').removeClass( 'is-active' )
	}
	
	function showSideBar() {
		$('#sideBar > .phone').addClass( 'is-active' )
	}
	function hideSideBar() {
		$('#sideBar > .phone').removeClass( 'is-active' )
	}
	
	// image loading
	for( const placeContainerElement of $('.place-container') ){
		let placeContainer:JQuery<HTMLElement> = $(placeContainerElement)
		const placeID:string = placeContainer.attr( 'data-id' )
		ViewUtils.performWhenScrollingIntoView( placeContainerElement, async() => {
			if( !DEBUG_shouldLoadImages )
				return
			
			const loadingState:LoadingState = placeContainer.attr( 'data-loading-state' ) as LoadingState
				?? LoadingState.NotLoaded
			if( /*already tried loading before*/loadingState != LoadingState.NotLoaded )
				// NOTE: do nothing if already tried to previously load (irrespective of success/failure outcome)
				return

			// load place
			placeContainer.attr( 'data-loading-state', LoadingState.Loading )
			const place:google.maps.places.PlaceResult = await getPlaceDetails( placeID )
			placeContainer.attr( 'data-loading-state', LoadingState.Loaded )
			
			// hydrate
			if( place.photos.length == 0 )
				return
			const photo:google.maps.places.PlacePhoto = place.photos[0]
			// NOTE: There are multiple image views because we have left/right views on desktop/tablet
			const imageViews = $(placeContainer).children( 'img' )
			for( const imageView of imageViews ){
				// NOTE: we use height here to support landscape image containers (ie: on mobile)
				const isImageViewInPortraitOrientation:boolean = imageView.width < imageView.height
				// const maxImageViewDimension:number = Math.max( imageView.width, imageView.height )
				imageView.setAttribute( 'src', photo.getUrl({
					maxWidth: (!isImageViewInPortraitOrientation) ? imageView.width : null,
					maxHeight: (isImageViewInPortraitOrientation) ? imageView.width : null,
				}))
			}
		})
	}
	
	// metrics
	// A1
	Metrics.logRegionPageViewed( _region.Identifier )
	// A2
	// Metrics.logRegionPageViewed( _Region )

	// app launch
	// TODO(DRY): generalize across pages?
	await Metrics.logAppClipsCapability()
	// console.debug( `ShouldLaunchApp: ${ShouldLaunchApp}` )
	// console.debug( `ShouldLaunchAppClip: ${ShouldLaunchAppClip}` )
	// A1: on-scroll (doesn't work consistently)
	if( ShouldLaunchAppClip ){
		if( ShouldAppClipsLaunchViaAppleLinks ){
			/*NOTE: ignore async*/await launchAppClip()
		} else { /*do nothing – handled via <meta> param*/ }
	} else if( ShouldLaunchApp ){
		// TODO: wire up scroll launch hook
		/*NOTE: ignore async*/await GLOBAL_launchApp()
	}
})


async function getPlaceDetails( id:string ): /*image URL*//*Promise<string>*/Promise<google.maps.places.PlaceResult> {
	console.info( `Fetching place #${id}...` )
	return await new Promise( (resolve, reject) => {
		placesService.getDetails(/*request:*/{
			placeId: id,
			fields: ['place_id', 'name', 'photos']
			// }, function( place:PlaceResult|null, status:PlacesServiceStatus ){
		}, function( place, status ){
			if( status != google.maps.places.PlacesServiceStatus.OK ){
				console.warn( `Could not fetch '${place.name}'` )
				return reject()
			}

			// hydrate
			console.info( `Fetched '${place.name}'` )
			return resolve( place )
		})
	})
}


function trackActivePlace({ isHighlightingEnabled }: { isHighlightingEnabled:boolean }) {
	const blurbElements:HTMLElement[] = $('#topSights .blurb').get()
	if( !blurbElements.length ) 
		return
	
	const highlightClass = 'highlight' as const
	const rankSets = new Set<number>()
	let highlightedRank:number|null = null
	
	// TODO: is 'placeID:string;' a typo?
	const getPlaceAttributes:(blurbEntry:IntersectionObserverEntry) => { placeID:string; rank:number, commercialLevel:CommercialLevel|null } = blurbEntry => {
		const placeContainer = $(blurbEntry.target).closest( '.place-container' )
		const placeID:string = placeContainer.attr( 'data-id' ) ?? ''
		const rank:number = Number( placeContainer.attr( 'data-rank' ) ?? 0 )
		const commercialLevel:CommercialLevel|null = (placeContainer.attr( 'data-commercial-level' ) as CommercialLevel) ?? null

		return { rank, placeID, commercialLevel }
	}

	const logPlaceSeen = debounce( (placeID:string, rank:number, commercialLevel:CommercialLevel|null) => {
		Metrics.logPlaceSeen( placeID, rank, commercialLevel )
	}, 500 )
	
	const findPlaceBlurbByRank = (rank:number) => {
		return $(`[data-rank='${rank}'] .blurb`)
	}
	const highlightPlace = () => {
		if( !isHighlightingEnabled || !rankSets.size ) 
			return
		
		const smallestRank:number = Math.min( ...rankSets )
		if( highlightedRank === smallestRank ) 
			return
		
		const activeBlurb:JQuery<Element> = findPlaceBlurbByRank( smallestRank )
		$(`#topSights .${highlightClass}`).removeClass( highlightClass )
		$(activeBlurb).addClass( highlightClass )
		highlightedRank = smallestRank
	}
	
	
	ViewUtils.observeElements({
		elements: blurbElements,
		onIntersect:(entry:IntersectionObserverEntry ) => {
			const { rank, placeID, commercialLevel } = getPlaceAttributes( entry )
			rankSets.add( rank )
			highlightPlace()
			
			// log event
			logPlaceSeen( placeID, rank, commercialLevel )
		},
	}, {
		threshold: 1,
	})

	ViewUtils.observeElements({
		elements: blurbElements,
		onLeave:(entry:IntersectionObserverEntry) => {
			const { rank } = getPlaceAttributes( entry )
			rankSets.delete( rank )
			highlightPlace()
		}
	}, {
		threshold: 0.6,
	})
}


// TODO: globalize
enum LoadingState {
	NotLoaded= "NotLoaded",
	Loading = "Loading",
	Loaded = "Loaded",
	Errored = "Errored",
}


let _experimentsPromise:Promise<typeof import( './Experiments' ).Experiments|undefined>|null = null
function loadExperiments() {
	if( _experimentsPromise )
		return _experimentsPromise
	
	_experimentsPromise = import( /* webpackChunkName: "experiments" */ './Experiments' )
		.then( _ => _.Experiments )
		.catch( x => {
			console.warn( 'Experiments load failed, skipping all flags',  x )
			return undefined
		})
	return _experimentsPromise
}
